
import {GET_FillAdminmonthyr} from '../constants/ActionTypes'

const INIT_STATE = {
    AdminMonthYr: null
 
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case GET_FillAdminmonthyr:
            return {
                AdminMonthYr: action.body
              
              
            }
           

        default:
            return state;
    }
}